import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export const SwipeHint = ({ hidden }) => {
  const [timeUp, setTimeUp] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setTimeUp(true), 5000);
    return () => clearTimeout(t);
  }, []);
  return (
    <AnimatePresence>
      {!hidden && !timeUp && (
        <motion.div
          data-testid="swipe-hint"
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="label pointer-events-none absolute bottom-12 left-1/2 z-10 flex -translate-x-1/2 items-center gap-2 border border-[#111111]/15 bg-[#F4F2EE]/90 px-3 py-2 text-[10px] md:hidden"
        >
          Swipe
          <motion.span animate={{ x: [0, 5, 0] }} transition={{ duration: 1.4, repeat: Infinity, ease: "easeInOut" }}>
            <ArrowRight size={12} strokeWidth={1.5} />
          </motion.span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
